import { state } from "./state";
import { CHANGAN_FINANCE_ID, creditFields, TRADE_IN_ID, BENEFIT, TRADE_IN_OTHER_ID, } from "./constants";

export const getSale = name => {
  const sales = (state.complectation || {}).sales;
  switch (name) {
    case 'sale':
      return sales.find(({ id }) => parseInt(id) === CHANGAN_FINANCE_ID).value;
    case 'tradein':
      return sales.find(({ id }) => parseInt(id) === TRADE_IN_ID).value;
    case 'benefit':
      return sales.find(({ id }) => parseInt(id) === BENEFIT)?.value;
    case 'tradeinother':
      const field = sales.find(({ id }) => parseInt(id) === TRADE_IN_OTHER_ID);
      return field ? field.value : null;
    default:
      return '';
  }
}

export const getPacket = () => {
  let price = null;
  state.credits.forEach(credit => {
    if (credit.installment_packet_price && (!price || credit.installment_packet_price < price)) {
      price = credit.installment_packet_price;
    }
  })

  return price;
}

export const getField = name => creditFields.filter((index, { dataset: { finance } }) => finance === name)[0];
